import { ExternalLink, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const COMMUNITIES = ["Las Vegas", "North Las Vegas", "Henderson", "Boulder City", "Paradise", "Spring Valley", "Enterprise", "Sunrise Manor", "Whitney", "Winchester", "Summerlin", "Centennial Hills"];
export default function ServiceAreaMap() {
  return <section id="serviceareamap" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Left Column: Heading, Community List, and Disclaimer Note */}
          <div className="lg:col-span-5 flex flex-col justify-start">
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-foreground">
              Las Vegas &amp; Southern Nevada Service Area
            </h2>

            <div className="mt-6 bg-card text-card-foreground border border-border rounded-xl p-6 shadow-xs">
              <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-4">
                Served Communities
              </h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                {COMMUNITIES.map((community, i) => <li key={community} data-index={i} className="flex items-center gap-2 text-sm text-foreground">
                    <MapPin className="size-4 shrink-0 text-primary" aria-hidden="true" />
                    <span>{community}</span>
                  </li>)}
              </ul>
            </div>

            <p className="mt-4 text-xs sm:text-sm text-muted-foreground leading-relaxed">
              Listing a community does not guarantee availability or delivery — coverage is confirmed with each quote.
            </p>
          </div>

          {/* Right Column: Google Maps Embed, External Link, and Base Note */}
          <div className="lg:col-span-7 flex flex-col">
            <div className="relative w-full aspect-[4/3] sm:aspect-[16/10] bg-muted rounded-xl overflow-hidden border border-border shadow-sm">
              <iframe title="Fridge Fleet Las Vegas service base" aria-label="Fridge Fleet Las Vegas service base" src="https://www.google.com/maps?q=7477+Ullom+Drive,+Las+Vegas,+Nevada&z=10&output=embed" className="w-full h-full border-0" loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade" />
            </div>

            <div className="mt-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <Button asChild variant="outline" size="sm" className="w-fit">
                <Link to="https://maps.google.com/?q=7477+Ullom+Drive+Las+Vegas+Nevada" newTab className="inline-flex items-center gap-1.5">
                  <span>Open in Google Maps</span>
                  <ExternalLink className="size-3.5" aria-hidden="true" />
                </Link>
              </Button>
            </div>

            <p className="mt-3 text-xs sm:text-sm text-muted-foreground leading-relaxed">
              Map location represents a Fridge Fleet service base. Delivery coverage, trailer availability, and requirements are confirmed with each quote.
            </p>
          </div>
        </div>
      </div>
    </section>;
}